import { SecurityController } from "../public-api";

export class HLong {

    public static isNullOrNullLong(value: any): boolean {
        if (value == undefined)
            return true;
        if (value == null || value == 0 || isNaN(value))
            return true;
        return false;
    }

    public static toLocaleString(value: number, securityController: SecurityController) {
        if (securityController.getLanguage() == null)
            return value.toLocaleString('es');

        return (value * 1).toLocaleString(securityController.getLanguage());
    }

}